<template>
  <v-app id="inspire">
    <navigation-drawer
      v-model="showDrawer"
    />

    <app-bar
      @appBarIconClicked="showDrawer = !showDrawer"
    />

    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <my-footer />
  </v-app>
</template>

<script>
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import AppBar from '@/components/AppBar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    AppBar,
    'my-footer': Footer,
    NavigationDrawer,
  },
  data: () => ({
    showDrawer: true,
  }),
  created() {
    this.$vuetify.theme.dark = true;
  },
};
</script>

<style scoped lang="scss">

</style>
